import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let routes = [
	{
		path: '/',
		redirect: 'index' // 重定向到默认页面
	},
	{
		path: '/',
		name: 'Index',
		redirect: '/index',
		// component: () => import(/* webpackChunkName: "login" */ '@/views/index/index.vue'),
		component: () => import(/* webpackChunkName: "login" */ '@/views/mall/index.vue'),
		meta: { title: '首页', whiteListed: true },
		children: [
			{
				path: 'index',
				name: 'MallIndex',
				component: () => import('@/views/mall/mallHome.vue'),
				meta: { title: '首页', whiteListed: true }
			},
			{
				path: 'purchase',
				name: 'MallPurchase',
				component: () => import('@/views/mall/purchase/index.vue'),
				meta: { title: '购买流程', whiteListed: true }
			}
		]
	},
	{
		path: '/chartDemo',
		name: 'ChartDemo',
		component: () => import('@/views/chartDemo.vue'),
		meta: { title: 'echarts-Demo页面', whiteListed: true }
	},
	{
		path: '/icons',
		name: 'Icons',
		component: () => import('@/views/icons/index.vue'),
		meta: { title: 'svg-icon预览', whiteListed: true }
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/login/login.vue'),
		meta: { title: '登录', whiteListed: true }
	},
	{
		path: '/redirect/:path*',
		name: 'Redirect',
		component: () => import('@/views/redirect/index'),
		meta: { title: '重定向', whiteListed: true }
	},
	{
		path: '*',
		redirect: '/'
	}
]

/**
 * router路由自动化挂载
 * require.context() 函数接收三个参数：
 * 1、要搜索的文件夹目录
 * 2、是否还应该搜索它的子目录
 * 3、以及一个匹配文件的正则表达式
 *
 * 此法用于动态引入文件
 *
 * 返回：一个函数，意思就是说，require.context模块导出（返回）一个（require）函数。
 * 该函数有三个属性：
 * 1、resolve： 是一个函数，它返回请求被解析后得到的模块 id。
 * 2、keys： 也是一个函数，它返回一个数组，由所有可能被上下文模块处理的请求组成。 此处 routerContext.keys() 打印的是 router 目录下所有'.js'结尾的文件集合
 * 3、id： 是上下文模块里面所包含的模块 id. 它可能在你使用 module.hot.accept 的时候被用到
 */
const routerContext = require.context('./', true, /\.js$/)
routerContext.keys().forEach(route => {
	// 如果是根目录的 index.js 、不处理
	if (route.startsWith('./index')) {
		return
	}
	const routerModule = routerContext(route)

	/**
	 * 兼容 import export 和 require module.export 两种规范
	 */
	routes = [...routes, ...(routerModule.default || routerModule)]
})

const createRouter = () =>
	new Router({
		mode: 'history',
		//  添加基础路径
		base: '/cjt-service/',
		scrollBehavior: () => ({ y: 0 }),
		routes: routes
	})

const router = createRouter()

export default router
